module.exports = __webpack_public_path__ + "static/media/chesscoin.da3f4b88.svg";